'use client'

import React from 'react'
import { AuthorGroup } from '@/blocks/common/FeaturedPosts/AuthorGroup'
import { type Post } from '@/payload-types'
import { getAuthors } from '@/utilities/authors'

interface Props {
  post: Post
  className?: string
}

export const BlogPostAuthorInfo: React.FC<Props> = ({ post, className }) => {
  const authors = getAuthors(post)

  return authors.length > 0 && <AuthorGroup authors={authors} size={20} className={className} />
}
